<template>
  <div>
    <v-btn @click.stop="dialog = true"
           color="primary"
    >
      <v-icon class="margin-right-small">mdi-plus-circle</v-icon>
      Add location alias
    </v-btn>
    <v-dialog v-model="dialog"
              max-width="500"
              persistent
    >
      <AddLocationsForm
        v-if="dialog"
        :showSuccess="showSuccess"
        :showFailure="showFailure"
        :connection="connection"
        @cancel="dialog = false"
        @ok="dialog = false"
        @new-locations="$emit('new-locations', $event)"
        @failure="$emit('failure', $event)"
      >
      </AddLocationsForm>
    </v-dialog>
  </div>
</template>

<script>
import AddLocationsForm from "./AddLocationsForm";
import { HubConnection } from "@microsoft/signalr";

export default {
  name:       "AddLocations",
  components: { AddLocationsForm },
  props:      {
    connection:  HubConnection,
    showSuccess: Function,
    showFailure: Function,
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped></style>
